module.exports = "/images/banorte.svg?4a4a33ea83360e7e5505c31e29bfa891";